import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class DragModalService {
  private modals: any[] = [];

  isDoubled(ident: string): boolean {
    const modalToRemove: any[] = this.modals.filter((e: any) => e.id === ident);
    return (modalToRemove.length > 1);
  }

  add(modal: any): void {
    this.modals.push(modal);
  }

  getIndex(ident: string): number {
    const modalToRemove: any[] = this.modals.filter((e: any) => e.id === ident);
    if (modalToRemove.length > 0) {
      return this.modals.indexOf(modalToRemove[0]);
    }
    return -1;
  }

  remove(ident: string): void {
    const modalToRemove: any[] = this.modals.filter((e: any) => e.id === ident);
    if (modalToRemove.length > 0) {
      const index: number = this.modals.indexOf(modalToRemove[0]);
      if (index > -1) {
        this.modals.splice(index, 1);
      }
    }
  }

  open(ident: string): void {
    const modal: any[] = this.modals.filter((e: any) => e.id === ident);
    if (modal.length > 0) {
      modal[0].open();
    }
  }

  close(ident: string): void {
    const modal: any[] = this.modals.filter((e: any) => e.id === ident);
    if (modal.length > 0) {
      modal[0].close();
    }
  }
}
